import { PatientAccountStatus, UserStatus } from '@common/types';
import { theme } from '@store';

const statusColorMap = {
  active: theme.palette.success.main,
  invitation_pending: theme.palette.warning.main,
  invitation_expired: theme.palette.error.main,
  password_reset: theme.palette.info.main,
  deactivated: theme.palette.lightGrey.dark,
  missing_mfa: theme.palette.lightGrey.dark,
} as const satisfies Record<UserStatus, string>;

export const getStatusColor = (status: UserStatus) =>
  statusColorMap[status] ?? theme.palette.lightGrey.dark;

// ? Should this be moved to i18n?
export const StatusLabels = {
  active: 'Active',
  deactivated: 'Deactivated',
  invitation_expired: 'Invitation expired',
  invitation_pending: 'Invitation pending',
  password_reset: 'Password reset',
  missing_mfa: 'Missing MFA',
} as const satisfies Record<UserStatus, string>;

const accountStatusColorMap = {
  Active: theme.palette.success.main,
  Ineligible: theme.palette.error.main,
  Inactive: theme.palette.grey[300],
} as const satisfies Record<PatientAccountStatus, string>;

export const getAccountStatusColor = (status: PatientAccountStatus) =>
  accountStatusColorMap[status] ?? 'lightGrey';
